/**
 * 【标题】:
 * 【描述】:
 * 【版权】:
 * 【作者】:
 * 【时间】: 2018/12/27 9:56
 */
// const SERVER_BASE_URL = 'http://192.168.1.160/';
const SERVER_BASE_URL = window.location.origin+'/';
// const SERVER_BASE_URL = 'https://trade.yfqha.com/';
// const SERVER_BASE_URL = 'http://www.savantfxs.com/';
const SERVER_BASE_URL2 = window.location.origin+'/';
// const TRADER_URL = 'trader-1/#/';
// const CALENDAR_URL = 'http://192.168.1.203/quanzi/#/calendar/index';
// const NEWSFLASH_URL = 'http://192.168.1.203/quanzi/#/newsFlash';
// const LOGIN_URL = '';

// 测试
const origin = window.location.origin;
// const origin = 'https://www.yfqha.com/';
let LOGIN_URL = 'https://www.savantfxs.com/mobile/zh-hant/m.html#/signIn';
let ENl = 'https://www.topmax1.com/#/';
let REGIST_URL = 'https://www.savantfxs.com/mobile/zh-hant/m.html#/signUp';
let ICOPDF_URL = 'http://cocp.ltd/VCEWhitePaper.pdf';
let CVVPDF_URL = 'http://cocp.ltd/cvv.pdf';
let FVGPDF_URL = 'http://cocp.ltd/fvg.pdf';
let YHXY_URL = 'http://cocp.ltd/CornucopiaTermsofUse.pdf';

// if(origin.indexOf('http://qa.rtdream.cn') !=-1) {
//   LOGIN_URL = 'http://qa.rtdream.cn:7777/mobile/en-us/m.html#/signIn';
//   REGIST_URL = 'http://qa.rtdream.cn:7777/mobile/en-us/m.html#/signUp';
// }


const TWITTER = 'https://twitter.com/';
const GOOGLE = 'https://www.google.com/gmail/about/';
const FACEBOOK = 'https://www.facebook.com/';
const INSTAG = 'https://www.instagram.com/';
const TELEGR = 'https://telegram.org/';
const MEDIUM = 'https://medium.com';
const YOUTU = 'https://www.youtube.com/';
const CALENDAR_URL = 'https://qa.rtdream.cn/#/calendar/index';
const NEWSFLASH_URL = 'https://qa.rtdream.cn/#/newsFlash';
const PDF_URL = 'http://www.savantfxs.com/contract.pdf';
const PDF_ACT = 'http://www.savantfxs.com/commpanyact.docx';
const PLCG_EXE = 'https://www.topmax1.com/topmax.exe';
const windowAPP = 'https://www.rbcoin.ltd/windows/download/cornucopia.exe';
const legalDocument = 'https://www.savantfxs.com/#/legalDocument/1';
const partners = 'https://www.savantfxs.com/#/partners';
const contactUs = 'https://www.savantfxs.com/#/contactUs';
const trader = 'https://www.savantfxs.com/#/trader';
const icopg = 'https://www.savantfxs.com/#/ico';
const Announcement = 'https://www.savantfxs.com/#/news/1';
const IndustryNews = 'https://www.savantfxs.com/#/news/2';
const assetintro = 'https://www.savantfxs.com/#/assetintro';
const legalDocument2 = 'https://www.savantfxs.com/#/legalDocument/2';
const legalDocument3 = 'https://www.savantfxs.com/#/legalDocument/3';
const legalDocument1 = 'https://www.savantfxs.com/#/legalDocument/1';
const andownuri = 'https://www.yfqha.com/download/android/BP%20Markets.apk';
const iphoneUri = 'https://ztk1o.beijingshegong.com/ymm5n2nmzd';
const rainbowuri = 'https://www.rbcoin.ltd/download/windows/rainbow.exe';

export default {
  andownuri,
  iphoneUri,
  rainbowuri,
  legalDocument1,
  legalDocument3,
  legalDocument2,
  assetintro,
  IndustryNews,
  Announcement,
  contactUs,
  icopg,
  trader,
  legalDocument,
  partners,
  ICOPDF_URL,
  FVGPDF_URL,
  windowAPP,
  CVVPDF_URL,
  SERVER_BASE_URL,
  SERVER_BASE_URL2,
  LOGIN_URL,
  ENl,
  REGIST_URL,
  TWITTER,
  GOOGLE,
  FACEBOOK,
  INSTAG,
  TELEGR,
  MEDIUM,
  YOUTU,
  CALENDAR_URL,
  NEWSFLASH_URL,
  PDF_URL,
  PDF_ACT,
  YHXY_URL,
  PLCG_EXE,
};



// WEBPACK FOOTER //
// ./src/common/baseConfig.js